import { gql } from '@apollo/client';

export const UPLOAD_ENTRY_COVER_PHOTO = gql`
  mutation UploadEntryCoverPhoto($input: EntryCoverPhotoUploadInput!) {
    uploadEntryCoverPhoto(input: $input)
  }
`;

export const REMOVE_ENTRY_COVER_PHOTO = gql`
  mutation RemoveEntryCoverPhoto($hobbyId: String!, $entryId: ID!) {
    removeEntryCoverPhoto(hobbyId: $hobbyId, entryId: $entryId)
  }
`;

export const GET_ENTRY_PHOTO_ALBUMS = gql`
  query GetEntryPhotoAlbums($hobbyId: String!, $entryId: ID!) {
    getEntryPhotoAlbums(hobbyId: $hobbyId, entryId: $entryId) { id label url provider visibility }
  }
`;

export const SAVE_ENTRY_PHOTO_ALBUM_LINK = gql`
  mutation SaveEntryPhotoAlbumLink($input: EntryPhotoAlbumLinkInput!) {
    saveEntryPhotoAlbumLink(input: $input) { id label url provider visibility }
  }
`;

export const REMOVE_ENTRY_PHOTO_ALBUM_LINK = gql`
  mutation RemoveEntryPhotoAlbumLink($hobbyId: String!, $entryId: ID!, $id: ID!) {
    removeEntryPhotoAlbumLink(hobbyId: $hobbyId, entryId: $entryId, id: $id)
  }
`;

export const GET_ENTRY_HIGHLIGHT_PHOTOS = gql`
  query GetEntryHighlightPhotos($hobbyId: String!, $entryId: ID!) {
    getEntryHighlightPhotos(hobbyId: $hobbyId, entryId: $entryId) { id url visibility updatedAt }
  }
`;

export const ADD_ENTRY_HIGHLIGHT_PHOTO = gql`
  mutation AddEntryHighlightPhoto($input: EntryHighlightPhotoUploadInput!) {
    addEntryHighlightPhoto(input: $input) { id url visibility updatedAt }
  }
`;

export const REMOVE_ENTRY_HIGHLIGHT_PHOTO = gql`
  mutation RemoveEntryHighlightPhoto($hobbyId: String!, $entryId: ID!, $id: ID!) {
    removeEntryHighlightPhoto(hobbyId: $hobbyId, entryId: $entryId, id: $id)
  }
`;

export const PROMOTE_ENTRY_PHOTO_TO_COVER = gql`
  mutation PromoteEntryPhotoToCover($hobbyId: String!, $entryId: ID!, $photoId: ID!) {
    promoteEntryPhotoToCover(hobbyId: $hobbyId, entryId: $entryId, photoId: $photoId)
  }
`;

export const GET_PHOTO_STORAGE_USAGE = gql`
  query GetPhotoStorageUsage { getPhotoStorageUsage { usedBytes limitBytes } }
`;

export const SET_ENTRY_CHECKLIST_ITEM_PACKED = gql`
  mutation SetEntryChecklistItemPacked($hobbyId: String!, $entryId: ID!, $itemId: ID!, $packed: Boolean!) {
    setEntryChecklistItemPacked(hobbyId: $hobbyId, entryId: $entryId, itemId: $itemId, packed: $packed)
  }
`;
